import {
  ChainId,
  CHAIN_ID_BIFROST_TESTNET as SDK_CHAIN_ID_BIFROST_TESTNET,
} from '@bifrost-platform/bifront-sdk-react-biholder';

// id
export const TESTNET_CHAIN_ID_BIFROST: ChainId = SDK_CHAIN_ID_BIFROST_TESTNET;
export const TESTNET_CHAIN_ID_ETHEREUM: ChainId = 11155111;
export const TESTNET_CHAIN_ID_ARBITRUM: ChainId = 421614;
export const TESTNET_CHAIN_ID_POLYGON: ChainId = 80001;
export const TESTNET_CHAIN_ID_BSC: ChainId = 97;
export const TESTNET_CHAIN_ID_BASE: ChainId = 84532;

export const TESTNET_CHAIN_IDS = [
  TESTNET_CHAIN_ID_BIFROST,
  TESTNET_CHAIN_ID_ETHEREUM,
  TESTNET_CHAIN_ID_ARBITRUM,
  TESTNET_CHAIN_ID_POLYGON,
  TESTNET_CHAIN_ID_BSC,
  TESTNET_CHAIN_ID_BASE,
];
